/**
 * The forced-enrolment marker (TO-591). A user who is required to have MFA but
 * has not enrolled is routed to enrolment — from first-login (`ENROL_MFA`) or
 * from a `403 MFA_ENROLMENT_REQUIRED` on any other surface. Completing that
 * enrolment GRANTS the pending role server-side, which revokes the session, so
 * the user must sign in again. The settings re-enrolment flow shares the same
 * callback page but does NOT revoke the session; this one-shot marker tells the
 * callback which case it is, so only the forced case is sent to re-login.
 *
 * sessionStorage (not local): scoped to the tab doing the enrolment, and gone
 * when it closes. Never holds a token — only the fact that enrolment was forced.
 */
/** The SPA entry that forces TOTP enrolment (TO-591) — the target of `ENROL_MFA` and the 403. */
export const FORCED_MFA_ENROLMENT_PATH = '/auth/mfa/enrol'

const FORCED_MFA_ENROLMENT_KEY = 'mfa-enrol:forced'

/** Mark the in-flight enrolment as forced, before starting the OAuth redirect. */
export function markForcedMfaEnrolment(): void {
	sessionStorage.setItem(FORCED_MFA_ENROLMENT_KEY, '1')
}

/**
 * Whether the completed enrolment was forced, clearing the marker so a later
 * settings re-enrolment in the same tab is not mistaken for a forced one.
 */
export function consumeForcedMfaEnrolment(): boolean {
	const forced = sessionStorage.getItem(FORCED_MFA_ENROLMENT_KEY) === '1'
	sessionStorage.removeItem(FORCED_MFA_ENROLMENT_KEY)
	return forced
}
